// extracted by mini-css-extract-plugin
module.exports = {"lowRiskColor":"#77e65c","mediumRiskColor":"#fffd3b","mediumHighRiskColor":"#ff863a","highRiskColor":"#ff1c23","unknownRiskColor":"#6199d1"};